// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hover\\:bg-secondary-100[data-v-3eadd0b8]:hover {\n  background: #1a7bee;\n}", ""]);
// Exports
module.exports = exports;
